import React, { Fragment, useEffect } from "react";
import { useAuth } from "@/shared/session";
import "@/utils/firebase/firebaseConfig";
import { identifyUser } from "./analytics";

const FirebaseProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, session } = useAuth();

  useEffect(() => {
    if (user?.id) {
      identifyUser(user.id, {
        user_email: user.email || "",
        user_zone: session?.zone || "",
        user_role: user.stocksConfig?.role?.label || "",
        platform: "stocks",
      });
    }
  }, [user?.id, user?.email, session?.zone, user?.stocksConfig?.role?.label]);

  return <Fragment>{children}</Fragment>;
};

export default FirebaseProvider;
